import React from 'react'

import { FormattedMessage } from 'react-intl'
import { useSelector } from 'react-redux'

import { EMPTY_LIST } from '@constants'
import { selectAudienceAgeRange } from '@store/rootResource'
import Theme from '@theme'
import { BlockText } from '../Block/Block.styled'

interface IProps {
  selectedAgeRange: ReadonlyArray<string>
}

export const getCompactAgeValues = (
  selectedAgeRange: ReadonlyArray<string>,
  audienceAgeRange: ReadonlyArray<string>,
) => {
  const rawPossibleMaxAge = selectedAgeRange!.find((value) => value.includes('+'))
  return audienceAgeRange.reduce((accum: string[], curr) => {
    if (!selectedAgeRange!.includes(curr)) {
      return accum
    }

    const [savedRangeStart, savedRangeEnd] = accum[accum.length - 1]?.split('-') || EMPTY_LIST

    const startOfCurrentRange = parseInt(curr.split('-')[0], 10)
    const endOfCurrentRange = isNaN(curr.split('-')[1] as any)
      ? rawPossibleMaxAge
      : parseInt(curr.split('-')[1], 10)

    if (parseInt(savedRangeEnd) + 1 === startOfCurrentRange) {
      return [...accum.slice(0, accum.length - 1), `${savedRangeStart}-${endOfCurrentRange}`]
    } else {
      return [...accum, curr]
    }
  }, [])
}

const CampaignPreviewPreferredAudienceAge: React.FC<IProps> = ({ selectedAgeRange }) => {
  const audienceAgeRange = useSelector(selectAudienceAgeRange)
  const valuesToDisplay = getCompactAgeValues(selectedAgeRange, audienceAgeRange)
  return (
    <BlockText small color={Theme.grey800Color}>
      <FormattedMessage
        id="campaign.preview.influencerDetails.age"
        values={{
          ageRange: valuesToDisplay.join(', '),
        }}
      />
    </BlockText>
  )
}

export default CampaignPreviewPreferredAudienceAge
